import { TYPES } from '../constants';
export const getBgColor = ({ theme, type }) => {
    switch (type) {
        case TYPES.DARK:
            return 'black';
        case TYPES.SUCCESS:
            return theme.colors.grass;
        case TYPES.WARNING:
            return theme.colors.mandarine;
        case TYPES.ERROR:
            return theme.colors.fire;
        case TYPES.LIGHT:
            return theme.colors.asphalt;
        case TYPES.INFO:
        default:
            return theme.colors.primary;
    }
};
//# sourceMappingURL=getBgColor.js.map